export default "__VITE_ASSET__9b6e2057__"